<template>
  <div class="container">

    <div class="jumbotron mt-5">
      <div class="col-sm-8 mx-auto">
        <h1 class="text-center">BrandMax WS</h1>
        <div v-if="remainingTime" class="text-center mt-3">
          <h1>{{ remainingTime }}</h1>
        </div>
      </div>

      <!-- <div class="h2 mb-0">
        <p>ICONOK</p>
        <b-icon-trash></b-icon-trash>
        <b-icon icon="bell-fill" class="rounded-circle bg-danger p-2" variant="light"></b-icon>        
        <b-icon-pencil-square></b-icon-pencil-square>
        <b-icon-pencil-fill></b-icon-pencil-fill>
        <b-icon-plus-circle></b-icon-plus-circle>
        <b-icon-printer></b-icon-printer>
        <b-icon-cloud-upload></b-icon-cloud-upload>
        <b-icon-arrow-left></b-icon-arrow-left>
        <b-icon-download></b-icon-download>
        <b-icon-search></b-icon-search>
        <b-icon-x-circle></b-icon-x-circle>
        <b-icon-arrow-clockwise></b-icon-arrow-clockwise>
      </div>       -->
    </div>
    <div>

    </div>

  </div>

</template>

<script>
import jwtDecode from 'jwt-decode'

export default {
  data () {
    return {
      token: localStorage.usertoken,
      remainingTime: ''
    }
  },
  methods: {
    calculateRemainingTime () {
      if (this.token) {
        const decoded = jwtDecode(this.token)
        const currentTime = Date.now() / 1000 // Aktuális idő másodpercben
        const expTime = decoded.exp // Token lejárati idő
        const timeLeft = expTime - currentTime

        if (timeLeft > 0) {
          const hours = Math.floor(timeLeft / 3600).toString().padStart(2, '0') // Teljes órák
          const minutes = Math.floor((timeLeft % 3600) / 60).toString().padStart(2, '0') // Teljes percek
          const seconds = Math.floor(timeLeft % 60).toString().padStart(2, '0') // Két számjegyű másodpercek
          this.remainingTime = `${hours}:${minutes}:${seconds}`
        } else {
          this.remainingTime = 'A rendszer automatikusan kiléptetett. Kérjük jelentkezz be újra.'
          this.logout() // Kijelentkezés, ha lejárt
        }
      }
    },
    logout () {
      // Kijelentkezési logika
    }
  },
  mounted () {
    if (this.token) {
      this.calculateRemainingTime() // Esetleg itt is indíthatjuk, ha már be van jelentkezve
    }
    setInterval(this.calculateRemainingTime, 1000) // Frissítés 1 másodpercenként
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue